import { render, staticRenderFns } from "./ProductIcon.vue?vue&type=template&id=6828c3b7"
import script from "./ProductIcon.vue?vue&type=script&lang=js"
export * from "./ProductIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports